import {
  Box,
  Flex,
  Text,
  Tooltip
} from '@chakra-ui/react';
import React from 'react';
import { CLIENT_CONFIG } from '../../core/client/buildConfig';

interface SidebarItemProps {
  icon?: React.ReactElement | null;
  label: string;
  onClick?: () => void;
  isSelected?: boolean;
  showLabel?: boolean;
  badge?: string | number;
  compact?: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  icon,
  label,
  onClick,
  isSelected = false,
  showLabel = true,
  badge,
  compact = false,
}) => {
  const selectedBgColor = 'primaryScheme.50';
  const hoverBgColor = 'primaryScheme.50';
  const selectedIndicatorColor = CLIENT_CONFIG.theme.colors.primary;
  const selectedTextColor = CLIENT_CONFIG.theme.colors.primary;
  const badgeBgColor = CLIENT_CONFIG.theme.colors.secondary;

  const content = (
    <Flex
      py={compact ? 1 : 2}
      px={2}
      ml={2}
      alignItems="center"
      borderRadius="md"
      cursor="pointer"
      onClick={onClick}
      transition="all 0.2s"
      justify={showLabel ? 'flex-start' : 'center'}
      position="relative"
      bg={isSelected ? selectedBgColor : 'transparent'}
      _hover={{
        bg: hoverBgColor,
      }}
      _before={{
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        bottom: '0',
        width: '3px',
        borderRadius: '0 4px 4px 0',
        bg: isSelected ? selectedIndicatorColor : 'transparent',
      }}
    >
      {icon && (
        <Box
          mr={showLabel ? (compact ? 1 : 2) : 0}
          fontSize="sm"
          opacity={0.8}
          color={isSelected ? selectedTextColor : 'inherit'}
          display="flex"
          alignItems="center"
        >
          {icon}
        </Box>
      )}

      {showLabel && (
        <Text
          flex="1"
          fontSize="sm"
          noOfLines={1}
          fontWeight={isSelected ? 'medium' : 'normal'}
          color={isSelected ? selectedTextColor : 'inherit'}
        >
          {label}
        </Text>
      )}

      {badge && showLabel && (
        <Box
          fontSize="xs"
          px={2}
          py={0.5}
          borderRadius="full"
          bg={badgeBgColor}
          color="white"
          ml={2}
          lineHeight="normal"
        >
          {badge}
        </Box>
      )}
    </Flex>
  );

  return showLabel ? content : (
    <Tooltip label={label} placement="right">
      {content}
    </Tooltip>
  );
};

export default SidebarItem;
